<template>
  <SideBar />

  <div class="p-4 sm:ml-64 min-h-screen dark:bg-gray-900 text-white">
    <div class="container mx-auto p-4">
      <!-- Componente de carga -->
      <div v-if="loading">
        <AppLoding />
      </div>
      <h1 class="text-3xl font-bold mb-6">Lista de Ventas</h1>

      <!-- Formulario de búsqueda -->
      <div class="bg-gray-800 p-4 rounded-lg shadow-lg mb-6">
        <form @submit.prevent="buscarVentas">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <!-- Campo de búsqueda por nombre -->
            <div>
              <label class="block text-gray-400 mb-2" for="nombreCliente"
                >Nombre del Cliente</label
              >
              <input
                v-model="filtros.nombre"
                type="text"
                id="nombreCliente"
                placeholder="Ingrese el nombre"
                class="w-full p-2 rounded-lg bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <!-- Campo de rango de fecha inicial -->
            <div class="w-full">
              <label class="block text-gray-400 mb-2" for="fechaInicio"
                >Fecha Inicio</label
              >
              <input
                v-model="filtros.fechaInicio"
                type="date"
                id="fechaInicio"
                class="w-full p-2 rounded-lg bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <!-- Campo de rango de fecha final -->
            <div class="w-full">
              <label class="block text-gray-400 mb-2" for="fechaFin"
                >Fecha Fin</label
              >
              <input
                v-model="filtros.fechaFin"
                type="date"
                id="fechaFin"
                class="w-full p-2 rounded-lg bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </form>
      </div>


      <router-link
        to="/venta"
        class="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex justify-center mb-6"
        exact-active-class="bg-gray-100 dark:bg-orange-500"
      >
        Nueva venta
      </router-link>

      <!-- Lista de ventas -->

      <RowComponent
        v-for="venta in ventasFiltradas"
        :key="venta.ID"
        :data=venta
        :h1="[venta.NOMBRE, `$${parseFloat(venta.TOTAL).toLocaleString('es-ES')}`]"
        :h2="[`Fecha: ${new Date(venta.DATE).toLocaleDateString()}`]"
        :actions="actions"
      />

    </div>
  </div>
</template>

<script>
import RowComponent from "@/components/RowComponent.vue";
import SideBar from "../components/NavBar.vue";
import AppLoding from "../components/AppLoding.vue";
import VentasProvider from "@/helpers/providers/VentasProvider";

export default {
  name: "VentasPage",
  data() {
    return {
      ventas: [], // Lista completa de presupuestos
      filtros: {
        nombre: "", // Nombre del cliente
        fechaInicio: new Date(new Date().setDate(new Date().getDate() - 14))
          .toISOString()
          .substr(0, 10), // Fecha de inicio (últimos 14 días)
        fechaFin: new Date(new Date().setDate(new Date().getDate() + 1))
          .toISOString()
          .substr(0, 10), // Fecha final
      },
      actions: [
         {
          icon: "fas fa-file-pdf",
          iconColor: "bg-orange-500",
          tooltip: "Ver PDF",
          onClick: (data) => this.handleVentaClick(data.UUID),
        },
        {
          icon: "fas fa-trash",
          iconColor: "bg-red-500",
          onClick: (data) => this.handleDeleteClick(data),
        },
      ],
    };
  },
  computed: {
    // Filtrar presupuestos según los criterios de búsqueda
    ventasFiltradas() {
      return this.ventas.filter((venta) => {
        const coincideNombre =
          !this.filtros.nombre ||
          venta.CLIENTE.toLowerCase().includes(
            this.filtros.nombre.toLowerCase()
          );
        const coincideFechaInicio =
          !this.filtros.fechaInicio ||
          new Date(venta.DATE) >= new Date(this.filtros.fechaInicio);
        const coincideFechaFin =
          !this.filtros.fechaFin ||
          new Date(venta.DATE) <= new Date(this.filtros.fechaFin);

        return coincideNombre && coincideFechaInicio && coincideFechaFin;
      });
    },
  },
  components: {
    SideBar,
    AppLoding,
    RowComponent,
  },
  methods: {
    async cargarVentas() {
      try {
        this.ventas = await VentasProvider.getVentas();
      } catch (error) {
        this.$notiflix.Notify.failure("Error al cargar ventas:", error);
        //this.$notiflix. Notify.failure("Error al cargar ventas:", error);

        // console.error("Error al cargar presupuestos:", error);
      }
    },
    buscarVentas() {
      //console.log("Criterios de búsqueda:", this.filtros);
    },
     async handleVentaClick(uuid) {
      await VentasProvider.getPDF(uuid);
    },
    async handleDeleteClick(venta) {
      this.$notiflix.Confirm.show(
        `Advertencia`,
        `Usted va a eliminar la venta de ${venta.NOMBRE} \n ¿Está seguro?`,
        "Si",
        "Cancelar",
        async () => {
          this.$notiflix.Loading.standard();
          await VentasProvider.deleteVenta(venta.UUID);
          await this.cargarVentas();
          this.$notiflix.Loading.remove();
          this.$notiflix.Notify.success("Venta eliminada correctamente");
        },
        () => {
          //no hacer nada
        },
        {
          titleColor: "#ef4444",
          okButtonBackground: "#ef4444",
        }
      );
    },
  },
 
  async mounted() {
    this.$notiflix.Loading.standard();
    await this.cargarVentas();
    this.$notiflix.Loading.remove();
  },
};
</script>
